var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { BASE_FONT_FAMILY, BASE_FONT_NORMAL_WEIGHT, FONT_LINE_HEIGHT_M, FONT_SIZE_M, SPACING_S } from "../../helpers";
import { useGridContext } from '../features';
var GridEmptyBox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", ";\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    font-family: ", ";\n    line-height: ", ";\n    flex: 1;\n"], ["\n    padding: ", ";\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    font-family: ", ";\n    line-height: ", ";\n    flex: 1;\n"])), SPACING_S, function (props) { return props.theme.colorTextLight; }, FONT_SIZE_M, BASE_FONT_NORMAL_WEIGHT, BASE_FONT_FAMILY, FONT_LINE_HEIGHT_M);
export var gridEmptyBoxId = 'grid-empty-box';
var GridEmpty = function (_a) {
    var _b = _a.text, text = _b === void 0 ? 'No data' : _b;
    var isLoading = useGridContext().state.isLoading;
    if (isLoading) {
        return null;
    }
    return React.createElement(GridEmptyBox, { "data-selector-id": gridEmptyBoxId }, text);
};
export default GridEmpty;
var templateObject_1;
//# sourceMappingURL=GridEmpty.js.map